var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 280",
    style: {
      enableBackground: "new 0 0 280 280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4F4F4;}\r\n\t.st1{fill:#CCCCCC;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noimage-user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noimage-user"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,280H0V0h280V280z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "USER",
    className: "st1",
    d: "M240,227.5L240,227.5c0,5.2-4.2,9.3-9.4,9.3H49.4c-5.1,0.1-9.3-4.1-9.4-9.2c0,0,0-0.1,0-0.1l0,0 c0,0,0-34.1,25-46.5c15.8-7.9,9.7-1.4,29.1-9.5s24-10.8,24-10.8l0.2-18.5c0,0-7.3-5.5-9.5-23c-4.5,1.3-6-5.3-6.3-9.6 c-0.2-4.1-2.6-16.9,2.9-15.7c-1.1-8.5-1.9-16.2-1.5-20.3c1.4-14.3,15.2-29.2,36.4-30.3c25,1.1,34.8,16,36.2,30.3 c0.4,4.1-0.5,11.8-1.6,20.3c5.5-1.1,3.1,11.6,2.9,15.7s-1.8,10.9-6.3,9.5c-2.3,17.4-9.5,22.9-9.5,22.9l0.2,18.4 c0,0,4.6,2.6,24,10.7s13.3,2,29.1,9.8C240,193.4,240,227.4,240,227.5L240,227.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankUser);
export default __webpack_public_path__ + "static/media/blank-user.8f3a343536a1e1866fb0a2ee6df992f1.svg";
export { ForwardRef as ReactComponent };